export default "__VITE_ASSET__CehGWa8j__"